import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FullReset } from '../../../../utilities/DL/PersonalSurfer';

/**
 * MODAL: PersonalSurferDangerModal
 * Zona Peligrosa: Reinicio maestro total de participantes y telemetría de la sala.
 * Protegido mediante la palabra clave "REINICIAR".
 */
export const PersonalSurferDangerModal = ({
    isOpen,
    onClose,
    roomId,
    onResetCompleted = () => {},
    triggerToast = () => {}
}) => {
    const [keyword, setKeyword] = useState('');
    const [isResetting, setIsResetting] = useState(false);

    if (!isOpen) return null;

    const isMatch = keyword.trim() === 'REINICIAR';

    const handleConfirm = async () => {
        if (!isMatch) {
            triggerToast('warning', 'Debes escribir exactamente la palabra "REINICIAR".');
            return;
        }

        setIsResetting(true);
        try {
            const res = await FullReset('REINICIAR', roomId);
            if (res.success) {
                triggerToast('success', 'Sala reiniciada exitosamente.');
                setKeyword('');
                onResetCompleted();
                onClose();
            } else {
                triggerToast('error', res.message || 'Error al ejecutar el reinicio.');
            }
        } catch (err) {
            triggerToast('error', 'Error crítico en el servidor.');
        } finally {
            setIsResetting(false);
        }
    };

    return (
        <div className="ps-modal-overlay">
            <div className="ps-modal-container ps-danger-modal">
                <div className="ps-modal-header ps-danger-header">
                    <h3>
                        <i className="bi bi-shield-slash-fill me-2 text-danger" />
                        Reinicio Maestro de la Sala
                    </h3>
                    <button type="button" className="ps-close-btn" onClick={onClose}>
                        <i className="bi bi-x-lg" />
                    </button>
                </div>

                <div className="ps-modal-body">
                    <div className="ps-alert-danger mb-3">
                        <i className="bi bi-exclamation-triangle-fill me-2" />
                        <strong>¡ADVERTENCIA DE ZONA PELIGROSA!</strong>
                        <p className="mb-0 mt-1">
                            Esta acción archivará de forma permanente todas las participaciones de la afición, limpiará el ranking y restablecerá a 0 los contadores de telemetría del partido anterior.
                        </p>
                    </div>

                    <p className="ps-label mb-2">
                        Para confirmar, escribe la palabra <strong className="text-danger">REINICIAR</strong> en el siguiente campo:
                    </p>
                    <input
                        type="text"
                        className="ps-input ps-input-danger"
                        placeholder="Escribe REINICIAR"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                        autoFocus
                    />
                </div>

                <div className="ps-modal-footer">
                    <button type="button" className="ps-btn ps-btn-secondary" onClick={onClose} disabled={isResetting}>
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="ps-btn ps-btn-danger"
                        onClick={handleConfirm}
                        disabled={!isMatch || isResetting}
                    >
                        <i className="bi bi-trash-fill me-1" />
                        {isResetting ? 'Purgando datos...' : 'Confirmar Purgado Total'}
                    </button>
                </div>
            </div>
        </div>
    );
};

PersonalSurferDangerModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    roomId: PropTypes.string,
    onResetCompleted: PropTypes.func,
    triggerToast: PropTypes.func
};
